export const paymentOptions = [
  {
    label: {
      children: 'Pay with credit/debit card',
    },
    value: 'stripe',
  },
  {
    label: {
      children: 'Pay over time with Affirm',
    },
    value: 'affirm',
  },
];
